import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getExcludeProfilesThunk } from "./asyncthunk";

interface IExcludeClient {
  id: number;
  name: string;
  platform: string;
  image_url: string;
  excluded_username: string;
  excluded_phone_number: string;
}

interface IInitialState {
  loading: boolean;
  error: string | null;
  excludeClientList: IExcludeClient[];
}

const initialState: IInitialState = {
  loading: false,
  error: null,
  excludeClientList: [],
};

const ExcludeClientSlice = createSlice({
  name: "excludeClient",
  initialState,
  reducers: {
    setDeleteExcludeClient: (state, action: PayloadAction<number>) => {
      state.excludeClientList = state.excludeClientList.filter(
        (item) => item.id !== action.payload,
      );
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getExcludeProfilesThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        getExcludeProfilesThunk.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          state.excludeClientList = (action.payload || []).map((item: any) => ({
            id: item.id,
            name: item.name || "",
            platform: item.platform || "",
            image_url:
              item.image_url ||
              "https://cdn-icons-png.flaticon.com/512/149/149071.png",
            excluded_username: item.excluded_username || "",
            excluded_phone_number: item.excluded_phone_number || "",
          }));
        },
      )
      .addCase(getExcludeProfilesThunk.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setDeleteExcludeClient } = ExcludeClientSlice.actions;

export const selectExcludeClientList = (state: any) =>
  state.excludeClientReducer.excludeClientList;
export const selectExcludeClientLoading = (state: any) =>
  state.excludeClientReducer.loading;

export default ExcludeClientSlice.reducer;
